import { observable } from "mobx";
import { Type } from "class-transformer";
import ReportRequestStatus from "./reportRequestStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InternalReportResponse {
  id!: string;

  @observable
  createdBy!: string;

  @observable
  @Type(() => Date)
  fromDate?: Date;

  @observable
  @Type(() => Date)
  toDate?: Date;

  @observable
  @Type(() => Date)
  _fromDate?: Date;

  @observable
  @Type(() => Date)
  _toDate?: Date;

  @observable
  @Type(() => Date)
  processedAt?: Date;

  @observable
  fileName!: string;

  @observable
  status!: ReportRequestStatus;
}
